import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const MicrosoftIcon = ({ size = 24, ...props }: SvgIconProps) => {
    return (
        <SvgIcon width={size} height={size} viewBox="0 0 24 24" {...props}>
            <title>{'Microsoft_logo'}</title>
            <desc>{'Created with Sketch.'}</desc>
            <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="02.integrations"
                    transform="translate(-448.000000, -274.000000)"
                    fillRule="nonzero"
                >
                    <g
                        id="Microsoft_logo"
                        transform="translate(448.000000, 274.000000)"
                    >
                        <rect
                            id="Rectangle-path"
                            fillOpacity="0"
                            fill="#F3F3F3"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                        />
                        <rect
                            id="Rectangle-path"
                            fill="#F35325"
                            x="0.929384966"
                            y="0.929384966"
                            width="10.6059226"
                            height="10.6059226"
                        />
                        <rect
                            id="Rectangle-path"
                            fill="#81BC06"
                            x="12.4646925"
                            y="0.929384966"
                            width="10.6059226"
                            height="10.6059226"
                        />
                        <rect
                            id="Rectangle-path"
                            fill="#05A6F0"
                            x="0.929384966"
                            y="12.4646925"
                            width="10.6059226"
                            height="10.6059226"
                        />
                        <rect
                            id="Rectangle-path"
                            fill="#FFBA08"
                            x="12.4646925"
                            y="12.4646925"
                            width="10.6059226"
                            height="10.6059226"
                        />
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

export default MicrosoftIcon;
